"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_file-upload-wrapper.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FileUploadWrapper = /*#__PURE__*/function (_Component) {
  _inherits(FileUploadWrapper, _Component);

  function FileUploadWrapper() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FileUploadWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FileUploadWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "createAsset", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(uploadedFiles) {
        var _this$props, addFileToQueue, selectedOrganisation, organisationId, _this$props2, addAssetId, type, groupType, subBrandId, file, fileName, name, bucketKey, payload, assetId;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, addFileToQueue = _this$props.addFileToQueue, selectedOrganisation = _this$props.selectedOrganisation;
                organisationId = selectedOrganisation.organisationId;

                if (!(0, _lodash.default)(uploadedFiles)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _this$props2 = _this.props, addAssetId = _this$props2.addAssetId, type = _this$props2.type, groupType = _this$props2.groupType, subBrandId = _this$props2.subBrandId;
                file = uploadedFiles[uploadedFiles.length - 1];
                fileName = file.name;
                name = type === 'FONT' ? fileName.substring(0, fileName.lastIndexOf('.')) : fileName;
                bucketKey = "organisation/".concat(organisationId, "/subBrand/").concat(subBrandId, "/").concat(groupType, "/").concat(name);
                payload = {
                  bucketKey: bucketKey,
                  file: file,
                  organisationId: organisationId,
                  metaData: {
                    type: file.type,
                    size: file.size
                  }
                };
                _context.next = 12;
                return addFileToQueue(payload);

              case 12:
                assetId = _context.sent;
                addAssetId(assetId);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(FileUploadWrapper, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          isVisible = _this$props3.isVisible,
          setFilePickerRef = _this$props3.setFilePickerRef,
          acceptedFileTypes = _this$props3.acceptedFileTypes,
          handleButtonClick = _this$props3.handleButtonClick,
          handleRemoveClick = _this$props3.handleRemoveClick,
          buttonPrefix = _this$props3.buttonPrefix,
          isRemovable = _this$props3.isRemovable;
      return _react.default.createElement("div", {
        className: "upload-wrapper",
        style: {
          display: isVisible ? 'flex' : 'none'
        }
      }, _react.default.createElement("div", {
        style: {
          visibility: isRemovable ? 'visible' : 'hidden'
        }
      }, _react.default.createElement(_uiKit.Icon, {
        name: "close",
        size: 15,
        color: "regent",
        onClick: handleRemoveClick
      })), _react.default.createElement("div", {
        className: "file-upload"
      }, _react.default.createElement(_reactFiles.default, {
        className: "file-upload__area",
        onChange: this.createAsset,
        accepts: acceptedFileTypes,
        multiple: false,
        clickable: false,
        ref: setFilePickerRef
      }, _react.default.createElement("p", {
        className: "drag-drop"
      }, "Drag & Drop"), _react.default.createElement("p", {
        className: "prefix-text"
      }, buttonPrefix, "\xA0", _react.default.createElement(_uiKit.LinkButton, {
        onClick: handleButtonClick
      }, "browse your files")))));
    }
  }]);

  return FileUploadWrapper;
}(_react.Component);

var _default = FileUploadWrapper;
exports.default = _default;